export default {
  version: 1, // Changing version logs out users
  apiHost: 'https://api.hauscanner.com/v1',
  googleAnalytics: 'G-MVYH4JQ6D2',
  maps: {
    apiKey: 'AIzaSyAZla3_Bh_P94wannMCrEG-jrs1BR2gEXA',
  },
  wompiPubKey: 'pub_test_LU8YE083OuNj3QbByeICjDiEu4CQ6uml',
};
